import * as THREE from "three";

export default (mesh, topLevel = false, instancedMesh = false) => {
    /*if(instancedMesh){
        mesh.children[0].geometry.computeVertexNormals();
        const iMesh = new THREE.InstancedMesh(
            mesh.children[0].geometry.clone(),
            mesh.children[0].material,
            1
        );
        iMesh.instanceMatrix.setUsage( THREE.DynamicDrawUsage );
        return iMesh;
    }*/
    if(topLevel){
        return new THREE.Mesh(
            mesh.geometry.clone(true),
            mesh.material
        )
    } else {
        return new THREE.Mesh(
            mesh.children[0].geometry.clone(),
            mesh.children[0].material
        )
    }
}